import { Component, OnInit, OnDestroy, Input, Output,EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, RouterModule } from "@angular/router";
import { HttpClient } from '@angular/common/http';
import { Observable, from, of, throwError, Subscription } from 'rxjs';

import { UrlService } from '@core/services/url/url.service';
import { TitleService } from '@core/services/title.service';

import { File } from '@core/objects/file';
import { Request, BasicRequest } from '@core/objects/request';
import { Version } from '@core/objects/version';

@Component({
    selector: 'share-transfer-select-files-section',
    templateUrl: './select-files.component.html',
    styleUrls: ['./select-files.component.scss']
})
export class PluginShareTransferSelectFilesSectionComponent implements OnInit, OnDestroy {

    public readonly LOADING = 0;
    public readonly DONE = 1;
    public readonly ERROR = 2;
    public readonly NOT_FOUND = 3;

    public readonly SELECTION_MODE_NONE = 0;
    public readonly SELECTION_MODE_FILE = 1;
    public readonly SELECTION_MODE_VERSION = 2;

    public pageStatus: number = this.LOADING;
    public version: Version;
    public filesUrl: string = "";
    public selectionMode: number = this.SELECTION_MODE_NONE;

    @Input() request: Request;
    @Input() requestHeader: BasicRequest;
    @Input() files: Array<File> = [];

    @Output() selectedChange = new EventEmitter<Array<File>>()

    public subscriptionRoutes: Subscription;

    constructor(private http: HttpClient, 
        public urlSrv: UrlService,
        private activeRoute: ActivatedRoute ){}


    ngOnInit() {

        // load query params
        this.subscriptionRoutes = this.activeRoute.queryParams.subscribe(params => {
            if ( params.version ) {
                this.loadVersion(Number(params.version));
                this.selectionMode = this.SELECTION_MODE_VERSION;
            } 
            if (params.file ) {
                this.selectionMode = this.SELECTION_MODE_FILE;
            }
        });

        if(this.request != null){
            this.filesUrl = "/requests/" + this.request.id +"/files";
        }

    }

    ngOnDestroy(){
        this.subscriptionRoutes?.unsubscribe();
    }
    onChange(e) {
        // console.log(" cambia  ",e);
        this.setSelected(e);
        this.selectedChange.emit(this.files);
    }

    onRemove(e) {
        let fileId = e.id;
        let files = this.files.filter(f => f.id != fileId);
        this.setSelected(files);
        this.selectedChange.emit(this.files);

    }

    setSelected(files: Array<File>){
        this.files = files;
    }

    private loadVersion(versionId: number) {
        this.http.get(this.urlSrv.build("/versions/" + versionId)).subscribe({
            next: (data:Version) => {
                this.version = data;
                this.pageStatus = this.DONE;
            },
            error: (error:any) => {
                this.pageStatus = this.ERROR;
            }
        });
    }

}
